module.exports = __webpack_public_path__ + "static/media/pontdugard.1380b7d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/pontdugard.png
// module id = 749
// module chunks = 0